import React from 'react';

import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { LoadingContainer } from './styles';

import { LoadingProps } from './interface';

const Loading: React.FC<LoadingProps> = ({ color, size }) => {
  return (
    <LoadingContainer>
      <span>
        <AiOutlineLoading3Quarters size={size ? size : 22} color={color} />
      </span>
    </LoadingContainer>
  );
};

export default Loading;
